import React from 'react';
import { useHistory } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import { useEntity } from '../contexts/EntityContext';
import ModuleSelectionComponent from '../components/ModuleSelectionComponent';

const ModulePage: React.FC = () => {
    const history = useHistory();
    const { currentEntity } = useEntity();

    // Check if entity is selected
    if (!currentEntity) {
        return (
            <div className="module-page">
                <Alert variant="warning" className="mt-4">
                    <Alert.Heading>Atenção</Alert.Heading>
                    <p>
                        Para acessar os módulos, você precisa selecionar uma entidade primeiro.
                    </p>
                    <hr />
                    <div className="d-flex justify-content-end">
                        <Button
                            variant="primary"
                            onClick={() => history.push('/home')}
                        >
                            Voltar para Seleção
                        </Button>
                    </div>
                </Alert>
            </div>
        );
    }

    const handleModuleSelect = (moduleType: string) => {
        switch (moduleType) {
            case 'acoes':
                history.push(`/acoes`);
                break;
            case 'auditoria':
                history.push(`/conformidade`);
                break;
            case 'visualizadorgeral':
                history.push(`/visualizadorgeral`);
                break;
            default:
                console.warn('Unknown module type:', moduleType);
        }
    };

    return (
        <div className="module-page">
            <ModuleSelectionComponent onModuleSelect={handleModuleSelect} />
        </div>
    );
};

export default ModulePage;
